// 네트워크별 환경설정
// REACT_APP_NETWORK 값으로 네트워크 선택: 'mainnet' | 'sepolia'
// REACT_APP_INFURA_KEY 로 인퓨라 키 설정

const NETWORK = (process.env.REACT_APP_NETWORK).toLowerCase();
const CONTRACT_ADDRESS = (process.env.REACT_APP_CONTRACT_ADDRESS).toLowerCase();
const INFURA_KEY = process.env.REACT_APP_INFURA_KEY;


const CONFIGS = {
  mainnet: {
    network: 'mainnet',
    rpcUrl: `https://mainnet.infura.io/v3/${INFURA_KEY}`,
    contractAddress: CONTRACT_ADDRESS,
    decimals: 18,
  },
  sepolia: {
    network: 'sepolia',
    rpcUrl: `https://sepolia.infura.io/v3/${INFURA_KEY}`,
    contractAddress: CONTRACT_ADDRESS,
    decimals: 18,
  },
};

export const getConfig = () => {
  return CONFIGS[NETWORK] || CONFIGS.mainnet;
};

export const CONTRACT_DECIMALS = () => getConfig().decimals;


